import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components/macro";

const StyledRichContent = styled.div`
  max-width: ${({ withMaxWidth }) => (withMaxWidth ? "650px" : "none")};

  @media (min-width: 800px) {
    max-width: ${({ withMaxWidth, customMaxWidth }) =>
      customMaxWidth ? customMaxWidth : withMaxWidth ? "650px" : "none"};
  }

  li {
    margin-bottom: 20px;
  }

  a {
    color: ${({ linkColor }) => linkColor};
    text-decoration: ${({ noLinkUnderline }) => noLinkUnderline && "none"};
  }

  /* Quick fix for youtube iframe – maybe fix a check later when fetching html and wrap youtune embed in a wrapper? */
  iframe {
    max-width: 100%;
    @media (max-width: 759px) {
      height: 60vw;
    }
  }

  ${(props) =>
    props.textCenter &&
    css`
      * {
        text-align: center;
      }
      ul {
        padding: 0;
        list-style: inside;
      }
      ol {
        list-style-position: inside;
        padding-left: inherit;
      }
    `}

  ${(props) =>
    props.extraSpace &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-bottom: 1em;
      }
    `}
`;

const RichContent = ({
  children,
  textCenter,
  extraSpace,
  className,
  linkColor,
  noLinkUnderline,
  withMaxWidth,
  customMaxWidth,
}) => {
  return (
    <StyledRichContent
      textCenter={textCenter}
      extraSpace={extraSpace}
      dangerouslySetInnerHTML={{ __html: children }}
      className={className}
      linkColor={linkColor}
      noLinkUnderline={noLinkUnderline}
      withMaxWidth={withMaxWidth}
      customMaxWidth={customMaxWidth}
    />
  );
};

RichContent.propTypes = {
  children: PropTypes.node,
  textCenter: PropTypes.bool,
  extraSpace: PropTypes.bool,
  className: PropTypes.string,
};

RichContent.defaultProps = {
  children: null,
  textCenter: false,
  extraSpace: false,
  className: undefined,
};

export default RichContent;
